import { useEffect } from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import { useDataModel } from '@thd-nucleus/data-sources';
import { useHelmet } from '@thd-nucleus/thd-helmet';
import { HD_URL } from '../../constants';
import { generateTags } from '../../utils/generate-tags';
import { kitchenCabinetModel } from '../../models';

const kitchenCabinetMetadataHandler = ({ data, props }) => {
  const { fetchCollectionsContent } = data || {};
  const { collectionName } = props;
  const { title, media } = fetchCollectionsContent || {};
  const { images } = media || {};
  const imageUrl = images?.[0]?.url || '';

  const canonical = `${HD_URL}/collection/kitchen-cabinets/${collectionName}`;
  const SEOTitle = [title, 'Kitchen', 'The Home Depot'].filter(Boolean).join(' - ');
  const SEODescription = `Shop our Kitchen Cabinets Department to customize your ${title || 'space'} today at The Home Depot`;

  const tags = generateTags({
    canonical,
    description: SEODescription,
    ogDescription: SEODescription,
    ogImage: imageUrl,
    ogSiteName: 'The Home Depot',
    ogTitle: SEOTitle,
    ogType: 'CustomKitchen',
    ogUrl: canonical,
    title: SEOTitle
  });

  return tags;
};

export const KitchenCabinetMetadata = ({ collectionName }) => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('kitchen-cabinet-metadata.ready');
  }, []);

  const kitchenCabinetOptions = {
    variables: {
      collectionName
    }
  };

  const { data } = useDataModel('fetchCollectionsContent', kitchenCabinetOptions);
  const props = { collectionName };

  useHelmet('kitchenCabinetMetadata', { data, props, skipCleanup: true }, kitchenCabinetMetadataHandler, [collectionName]);

  return null;
};

KitchenCabinetMetadata.displayName = 'KitchenCabinetMetadata';

KitchenCabinetMetadata.dataModel = kitchenCabinetModel;

KitchenCabinetMetadata.propTypes = {
  collectionName: string.isRequired
};